import { queryOptions } from "@tanstack/react-query";
import type { ServerHealthResponse } from "@/app/servers/types";
import type { ScopedBinding } from "@/app/types";
import type { ApiClient } from "@/lib/api";
import { getEngineApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";
import { serversKeys } from "./query-keys";

const checkHealth = async (options: {
  client: ApiClient;
  serverId: string;
}): Promise<ServerHealthResponse> => {
  const { client, serverId } = options;
  const { data } = await client.get<ServerHealthResponse>(
    `/workers/${serverId}/health`
  );
  return data;
};

export const checkHealthQueryOptions = ({
  serverId,
  binding = "project",
  refetchInterval,
  scope,
}: {
  serverId: string;
  binding?: ScopedBinding;
  refetchInterval?: number;
  scope: OrgProjectScope;
}) => {
  const client = getEngineApi(scope, binding);

  return queryOptions<ServerHealthResponse>({
    queryKey: serversKeys.health({ serverId, binding, scope }),
    queryFn: () => checkHealth({ client, serverId }),
    refetchInterval,
  });
};
